/* eslint-disable */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import api from './api';
import SliderPage from './SliderPage';
import TrackingTable from './TrackingTable';
import CDNGenerator from './CDNGenerator';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Cell } from 'recharts';
import { toast } from 'react-toastify';
import { FaUsers, FaEye, FaMousePointer, FaClock } from 'react-icons/fa';

const UserTrackingDashboard = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [aggPage, setAggPage] = useState(1);
  const [sessionsPage, setSessionsPage] = useState(1);
  const [ipClicksSearchTerm, setIpClicksSearchTerm] = useState('');
  const [ipClicksPage, setIpClicksPage] = useState(1);
  const itemsPerPage = 5;
  const sessionsPerPage = 10;
  const ipClicksPerPage = 10;

  const [activeTab, setActiveTab] = useState(() => localStorage.getItem('active_tab') || 'overview');
  const [expandedSessions, setExpandedSessions] = useState({});
  const [expandedIpClicks, setExpandedIpClicks] = useState({});
  const [expandedLiveIps, setExpandedLiveIps] = useState({});
  const [expandedGeoCountries, setExpandedGeoCountries] = useState({});
  const [sessionEventsPages, setSessionEventsPages] = useState({});
  
  const [dbTypeSel, setDbTypeSel] = useState('file');
  const [fileDbPath, setFileDbPath] = useState('');
  const [mongoUri, setMongoUri] = useState('');
  const [mongoDbName, setMongoDbName] = useState('');
  const [mongoCollName, setMongoCollName] = useState('');
  const [mysqlHost, setMysqlHost] = useState('');
  const [mysqlPort, setMysqlPort] = useState('3306');
  const [mysqlUser, setMysqlUser] = useState('');
  const [mysqlPass, setMysqlPass] = useState('');
  const [mysqlDb, setMysqlDb] = useState('');
  const [mysqlTable, setMysqlTable] = useState('clicks');
  const [azureHost, setAzureHost] = useState('');
  const [azurePort, setAzurePort] = useState('1433');
  const [azureUser, setAzureUser] = useState('');
  const [azurePass, setAzurePass] = useState('');
  const [azureDb, setAzureDb] = useState('');
  const [azureTable, setAzureTable] = useState('clicks');
  const hasInitializedDbConfig = useRef(false);

  const [allLogs, setAllLogs] = useState([]);
  const [deleteTabPage, setDeleteTabPage] = useState(1);
  const [deleteTabTotalPages, setDeleteTabTotalPages] = useState(1);
  const [deleteTabTotalCount, setDeleteTabTotalCount] = useState(0);
  const [selectedLogIds, setSelectedLogIds] = useState([]);
  const [deleteTabLoading, setDeleteTabLoading] = useState(false);
  const [mgrStartDate, setMgrStartDate] = useState('');
  const [mgrEndDate, setMgrEndDate] = useState('');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    localStorage.setItem('active_tab', tab);
  };

  useEffect(() => {
    fetchStats();
    const interval = setInterval(() => {
      fetchStats();
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const getTrafficSource = (referrer) => {
    if (!referrer) return { name: 'Direct', color: 'badge bg-secondary' };
    const cleanReferrer = referrer.toLowerCase();
    if (cleanReferrer.includes('whatsapp') || cleanReferrer.includes('wa.me')) {
      return { name: 'WhatsApp', color: 'badge bg-success' };
    }
    if (cleanReferrer.includes('telegram') || cleanReferrer.includes('t.me')) {
      return { name: 'Telegram', color: 'badge bg-info text-dark' };
    }
    try {
      const url = new URL(referrer);
      const host = url.hostname.toLowerCase();
      if (host.includes('facebook.com') || host.includes('fb.com')) {
        return { name: 'Facebook', color: 'badge bg-primary' };
      }
      if (host.includes('instagram.com')) {
        return { name: 'Instagram', color: 'badge bg-danger' };
      }
      if (host.includes('twitter.com') || host.includes('t.co') || host.includes('x.com')) {
        return { name: 'Twitter / X', color: 'badge bg-dark' };
      }
      if (host.includes('linkedin.com')) {
        return { name: 'LinkedIn', color: 'badge bg-primary' };
      }
      if (host.includes('youtube.com') || host.includes('youtu.be')) {
        return { name: 'YouTube', color: 'badge bg-danger' };
      }
      if (host.includes('google.com') || host.includes('google.co')) {
        return { name: 'Google Search', color: 'badge bg-success' };
      }
      return { name: `Referral (${url.hostname})`, color: 'badge bg-warning text-dark' };
    } catch (e) {
      return { name: referrer, color: 'badge bg-secondary' };
    }
  };

  const formatDuration = (totalSeconds) => {
    if (!totalSeconds || isNaN(totalSeconds)) return '0s';
    const hrs = Math.floor(totalSeconds / 3600);
    const mins = Math.floor((totalSeconds % 3600) / 60);
    const secs = totalSeconds % 60;
    const parts = [];
    if (hrs > 0) parts.push(`${hrs}h`);
    if (mins > 0) parts.push(`${mins}m`);
    if (secs > 0 || parts.length === 0) parts.push(`${secs}s`);
    return parts.join(' ');
  };

  const getEventActionDetails = (event) => {
    const is404 = event.eventType === 'page_404';
    const isFormError = event.eventType === 'form_error';
    const isPageView = event.eventType === 'page_view';
    const isUnload = event.eventType === 'page_unload' || event.buttonName === 'unload';
    const isLink = event.eventType === 'link_click' || (event.linkUrl && event.linkUrl !== 'null');
    const isForm = event.eventType === 'form_submit' || (event.buttonName && event.buttonName.toLowerCase().includes('submit'));
    
    if (is404) {
      return { action: 'Page 404 Error', details: `Visited missing URL: ${event.url}`, badge: 'badge bg-danger' };
    }
    if (isFormError) {
      return { action: 'Form Submit Fail', details: `Form error on "${event.buttonName}": ${event.errorDetails || 'Validation failed'}`, badge: 'badge bg-warning text-dark' };
    }
    if (isPageView) {
      return { action: 'Viewed Page', details: event.pageTitle || 'N/A', badge: 'badge bg-primary' };
    }
    if (isUnload) {
      return { action: 'Left Website', details: `Stayed for ${event.duration || 0} seconds`, badge: 'badge bg-secondary' };
    }
    if (isLink) {
      return { action: 'Clicked Link', details: `"${event.buttonName || 'Link'}" ➔ ${event.linkUrl || event.url}`, badge: 'badge bg-info text-dark' };
    }
    if (isForm) {
      return { action: 'Submitted Form', details: `"${event.buttonName || 'Submit'}" button`, badge: 'badge bg-success' };
    }
    return { action: 'Clicked Button', details: `"${event.buttonName || 'Click'}" on "${event.pageTitle || 'page'}"`, badge: 'badge bg-success' };
  };

  const fetchStats = async () => {
    try {
      const response = await api.get('/stats');
      setStats(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching stats:', error);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (stats?.dbConfig && !hasInitializedDbConfig.current) {
      const cfg = stats.dbConfig;
      setDbTypeSel(cfg.type || 'file');
      if (cfg.type === 'file') {
        setFileDbPath(cfg.filePath || '');
      } else if (cfg.type === 'mongodb') {
        setMongoUri(cfg.connectionString || '');
        setMongoDbName(cfg.database || '');
        setMongoCollName(cfg.collection || '');
      } else if (cfg.type === 'mysql') {
        setMysqlHost(cfg.host || '');
        setMysqlPort(cfg.port || '3306');
        setMysqlUser(cfg.username || '');
        setMysqlPass(cfg.password || '');
        setMysqlDb(cfg.database || '');
        setMysqlTable(cfg.table || 'clicks');
      } else if (cfg.type === 'azure') {
        setAzureHost(cfg.host || '');
        setAzurePort(cfg.port || '1433');
        setAzureUser(cfg.username || '');
        setAzurePass(cfg.password || '');
        setAzureDb(cfg.database || '');
        setAzureTable(cfg.table || 'clicks');
      }
      hasInitializedDbConfig.current = true;
    }
  }, [stats?.dbConfig]);

  const handleDbConnectNew = async (e, type) => {
    e.preventDefault();
    let payload = { type };
    if (type === 'file') {
      payload.filePath = fileDbPath;
    } else if (type === 'mongodb') {
      payload.connectionString = mongoUri;
      payload.database = mongoDbName;
      payload.collection = mongoCollName;
    } else if (type === 'mysql') {
      payload.host = mysqlHost;
      payload.port = mysqlPort;
      payload.username = mysqlUser;
      payload.password = mysqlPass;
      payload.database = mysqlDb;
      payload.table = mysqlTable;
    } else if (type === 'azure') {
      payload.host = azureHost;
      payload.port = azurePort;
      payload.username = azureUser;
      payload.password = azurePass;
      payload.database = azureDb;
      payload.table = azureTable;
    }

    try {
      const response = await api.post('/connect-database', payload);
      if (response.data.success) {
        toast.success(response.data.message || 'Connected successfully!');
        fetchStats();
      } else {
        toast.error(response.data.error || 'Failed to connect');
      }
    } catch (error) {
      toast.error('Connection error: ' + error.message);
    }
  };

  const fetchDeleteTabLogs = async () => {
    setDeleteTabLoading(true);
    try {
      const response = await api.get(`/clicks?page=${deleteTabPage}&limit=15`);
      if (response.data.success) {
        setAllLogs(response.data.data.clicks || []);
        setDeleteTabTotalPages(response.data.data.totalPages || 1);
        setDeleteTabTotalCount(response.data.data.total || 0);
      }
    } catch (e) {
      console.error(e);
      toast.error('Failed to load logs');
    }
    setDeleteTabLoading(false);
  };

  useEffect(() => {
    if (activeTab === 'deleteManager') {
      fetchDeleteTabLogs();
    }
  }, [activeTab, deleteTabPage]);

  const handleDeleteRangeMgr = async () => {
    if (!mgrStartDate || !mgrEndDate) {
      toast.error('Please select both start and end dates');
      return;
    }
    try {
      const response = await api.delete(`/clear?startDate=${mgrStartDate}&endDate=${mgrEndDate}`);
      if (response.data.success) {
        toast.success(response.data.message || 'Logs deleted successfully!');
        setMgrStartDate('');
        setMgrEndDate('');
        setDeleteTabPage(1);
        setSelectedLogIds([]);
        fetchDeleteTabLogs();
        fetchStats();
      } else {
        toast.error(response.data.error || 'Failed to delete logs');
      }
    } catch (e) {
      toast.error('Server error during deletion');
    }
  };

  const handleDeleteChecked = async () => {
    if (selectedLogIds.length === 0) {
      toast.error('No logs selected for deletion');
      return;
    }
    try {
      const response = await api.delete('/delete-logs', { data: { ids: selectedLogIds } });
      if (response.data.success) {
        toast.success(response.data.message || 'Selected logs deleted successfully!');
        setSelectedLogIds([]);
        fetchDeleteTabLogs();
        fetchStats();
      } else {
        toast.error(response.data.error || 'Failed to delete logs');
      }
    } catch (e) {
      toast.error('Server error during deletion');
    }
  };

  const handleDeleteAllMgr = async () => {
    if (!window.confirm('Warning: This will permanently delete ALL tracking logs. Proceed?')) return;
    try {
      const response = await api.delete('/clear');
      if (response.data.success) {
        toast.success('All logs cleared successfully!');
        setSelectedLogIds([]);
        setDeleteTabPage(1);
        fetchDeleteTabLogs();
        fetchStats();
      } else {
        toast.error(response.data.error || 'Failed to clear logs');
      }
    } catch (e) {
      toast.error('Server error during deletion');
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedLogIds(allLogs.map(log => log.id).filter(Boolean));
    } else {
      setSelectedLogIds([]);
    }
  };

  const handleToggleCheckbox = (id) => {
    setSelectedLogIds(prev => 
      prev.includes(id) ? prev.filter(item => item !== id) : [...prev, id]
    );
  };

  const chartData = stats?.clicksByButton ? Object.entries(stats.clicksByButton).map(([name, value]) => ({
    name: name.length > 12 ? name.substring(0, 12) + '...' : name,
    clicks: value
  })) : [];

  const filteredAggregated = stats?.aggregatedClicks
    ? stats.aggregatedClicks.filter(item => 
        item.buttonName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.pageTitle.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item.url.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : [];

  const totalAggPages = Math.ceil(filteredAggregated.length / itemsPerPage);
  const paginatedAggregated = filteredAggregated.slice((aggPage - 1) * itemsPerPage, aggPage * itemsPerPage);

  const renderOverviewTab = () => {
    return (
      <div className="d-flex flex-column gap-4">
        {/* Statistics Widgets */}
        <div className="row g-3">
          <div className="col-6 col-lg-3">
            <div className="card-stat-premium stat-visitors">
              <div className="stat-icon-wrapper">
                <FaUsers />
              </div>
              <div className="stat-info">
                <span className="stat-label">Total Visitors</span>
                <h3 className="stat-value mb-0">{stats?.totalVisitors || 0}</h3>
              </div>
            </div>
          </div>
          <div className="col-6 col-lg-3">
            <div className="card-stat-premium stat-views">
              <div className="stat-icon-wrapper">
                <FaEye />
              </div>
              <div className="stat-info">
                <span className="stat-label">Page Views</span>
                <h3 className="stat-value mb-0">{stats?.totalPageViews || 0}</h3>
              </div>
            </div>
          </div>
          <div className="col-6 col-lg-3">
            <div className="card-stat-premium stat-clicks">
              <div className="stat-icon-wrapper">
                <FaMousePointer />
              </div>
              <div className="stat-info">
                <span className="stat-label">Interaction Clicks</span>
                <h3 className="stat-value mb-0">{stats?.totalClicks || 0}</h3>
              </div>
            </div>
          </div>
          <div className="col-6 col-lg-3">
            <div className="card-stat-premium stat-duration">
              <div className="stat-icon-wrapper">
                <FaClock />
              </div>
              <div className="stat-info">
                <span className="stat-label">Avg Duration</span>
                <h3 className="stat-value mb-0">{stats?.avgDuration ? `${stats.avgDuration}s` : '0s'}</h3>
              </div>
            </div>
          </div>
        </div>

        {/* Recent Form Submissions Section */}
        <div className="card-premium">
          <h3 className="h6 mb-3 text-dark font-weight-bold">Recent Form Submissions (Latest First)</h3>
          {stats?.formSubmissions && stats.formSubmissions.length > 0 ? (
            <div className="row g-3" style={{ maxHeight: '350px', overflowY: 'auto' }}>
              {stats.formSubmissions.map((sub, idx) => (
                <div key={idx} className="col-md-6">
                  <div className="p-3 bg-light border rounded-3 d-flex flex-column gap-2">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <span className="small font-weight-bold text-dark">{sub.realName || sub.ipAddress}</span>
                        <span className="d-block text-muted font-monospace" style={{ fontSize: '10px' }}>{sub.ipAddress}</span>
                      </div>
                      <span className="small text-muted font-monospace">
                        {new Date(sub.timestamp).toLocaleTimeString()}
                      </span>
                    </div>
                    
                    <div className="small text-muted border-top pt-2">
                      Form ID: <span className="text-primary font-weight-bold">{sub.formId}</span>
                    </div>

                    <div>
                      <span className="d-block small text-muted mb-1 text-uppercase font-weight-bold" style={{ fontSize: '9px' }}>Submitted Data:</span>
                      <div className="d-flex flex-wrap gap-2">
                        {Object.entries(sub.formFields || {}).map(([key, val]) => (
                          <div key={key} className="bg-white border px-2 py-0.5 rounded" style={{ fontSize: '11px' }}>
                            <span className="text-muted font-weight-bold">{key}:</span> <span className="font-monospace text-primary">{String(val)}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-4 text-muted">No form submissions received yet.</div>
          )}
        </div>

        {/* Charts */}
        <div className="card-premium">
          <h3 className="h6 mb-4 text-dark font-weight-bold">Button Click Distribution</h3>
          {chartData.length > 0 ? (
            <div className="chart-container" style={{ height: '300px' }}>
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={chartData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#e9e9e9" />
                  <XAxis dataKey="name" stroke="#6c757d" fontSize={11} />
                  <YAxis stroke="#6c757d" fontSize={11} />
                  <Tooltip 
                    contentStyle={{ backgroundColor: '#fff', borderColor: '#dee2e6', borderRadius: '8px' }}
                    labelStyle={{ color: '#495057' }}
                    itemStyle={{ color: '#526cfe' }}
                  />
                  <Bar dataKey="clicks" radius={[4, 4, 0, 0]}>
                    {chartData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={index % 2 === 0 ? '#526cfe' : '#530cb3'} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
          ) : (
            <div className="d-flex align-items-center justify-content-center border border-dashed rounded-3 py-5 text-muted">
              No chart data generated yet
            </div>
          )}
        </div>

        {/* Aggregated Click Table */}
        <div className="card-premium">
          <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3 mb-4">
            <div>
              <h3 className="h5 text-dark mb-1">Button Click Analytics</h3>
              <p className="small text-muted mb-0">Total click counts aggregated per button on each page</p>
            </div>
            
            <div className="w-100 w-sm-auto" style={{ maxWidth: '250px' }}>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => { setSearchTerm(e.target.value); setAggPage(1); }}
                placeholder="Search buttons, pages..."
                className="form-control form-control-sm"
              />
            </div>
          </div>

          <div className="table-responsive border rounded-3">
            <table className="table table-striped table-hover mb-0">
              <thead>
                <tr>
                  <th className="px-3 py-3">Page Title</th>
                  <th className="px-3 py-3">URL</th>
                  <th className="px-3 py-3">Button Identifier</th>
                  <th className="px-3 py-3 text-end">Click Count</th>
                </tr>
              </thead>
              <tbody>
                {paginatedAggregated.length > 0 ? (
                  paginatedAggregated.map((item, index) => (
                    <tr key={index} className="event-row">
                      <td className="px-3 py-3 text-truncate" style={{ maxWidth: '180px' }}>
                        {item.pageTitle}
                      </td>
                      <td className="px-3 py-3 font-monospace text-truncate" style={{ maxWidth: '200px' }}>
                        <a href={item.url} target="_blank" rel="noopener noreferrer" className="text-primary text-decoration-none">
                          {item.url.replace(/https?:\/\//, '')}
                        </a>
                      </td>
                      <td className="px-3 py-3">
                        <span className="badge bg-secondary">
                          {item.buttonName}
                        </span>
                      </td>
                      <td className="px-3 py-3 text-end font-weight-bold text-dark">
                        <span className="badge bg-light border text-primary">
                          {item.count} clicks
                        </span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center py-4 text-muted">
                      No button click records matching search.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {totalAggPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-4">
              <span className="small text-muted">
                Page {aggPage} of {totalAggPages}
              </span>
              <div className="btn-group btn-group-sm">
                <button
                  onClick={() => setAggPage(p => Math.max(1, p - 1))}
                  disabled={aggPage === 1}
                  className="btn btn-outline-secondary"
                >
                  Previous
                </button>
                <button
                  onClick={() => setAggPage(p => Math.min(totalAggPages, p + 1))}
                  disabled={aggPage === totalAggPages}
                  className="btn btn-outline-secondary"
                >
                  Next
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };

  const renderLiveTab = () => {
    const fiveMinutesAgo = Date.now() - 5 * 60 * 1000;
    const activeVisitors = stats?.sessionsList 
      ? [...stats.sessionsList]
          .filter(s => new Date(s.endTime).getTime() >= fiveMinutesAgo)
          .sort((a, b) => new Date(b.endTime) - new Date(a.endTime))
      : [];

    return (
      <div className="d-flex flex-column gap-4">
        {/* Real-time Header */}
        <div className="d-flex justify-between align-items-center bg-light border p-4 rounded-3">
          <div>
            <h3 className="h5 text-dark mb-1">
              Real-Time Tracking Stream
            </h3>
            <p className="small text-muted mb-0">Live tracking active. View page entries and clicks as they happen.</p>
          </div>
          <div className="bg-white border px-3 py-2 rounded-3 text-center">
            <span className="small text-muted text-uppercase d-block" style={{ fontSize: '10px' }}>Active Users (5m)</span>
            <span className="h4 text-danger font-monospace mb-0 font-weight-bold">{stats?.activeUsers || 0}</span>
          </div>
        </div>

        {/* List of Active Visitors */}
        <div className="card-premium">
          <h4 className="h6 text-muted mb-3 text-uppercase font-weight-bold" style={{ fontSize: '12px' }}>Active Visitors & Activities</h4>
          
          <div className="d-flex flex-column gap-3" style={{ maxHeight: '600px', overflowY: 'auto' }}>
            {activeVisitors.length > 0 ? (
              activeVisitors.map((visitor, idx) => {
                const isExpanded = !!expandedLiveIps[visitor.ipAddress];
                const chronEvents = [...visitor.events].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
                const landingEvent = chronEvents[0];
                const trafficSource = getTrafficSource(landingEvent?.referrer);
                const latestEvents = [...visitor.events].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

                return (
                  <div key={idx} className="p-3 bg-white border rounded-3 d-flex flex-column gap-3">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
                      <div>
                        <div className="d-flex align-items-center gap-2 flex-wrap">
                          <span className="font-weight-bold text-primary">{visitor.userName}</span>
                          <span className="small text-muted font-monospace">({visitor.ipAddress})</span>
                          <span className={`${trafficSource.color}`}>
                            {trafficSource.name}
                          </span>
                        </div>
                        <div className="small text-muted mt-1">
                          System: {visitor.os || 'OS'} • Device: {visitor.device} ({visitor.browser}) • Location: {visitor.country || 'India'}
                        </div>
                      </div>

                      <div className="d-flex align-items-center gap-3 w-100 w-md-auto justify-content-between justify-content-md-end shrink-0">
                        <span className="small text-muted font-monospace">
                          Last: {new Date(visitor.endTime).toLocaleTimeString()}
                        </span>
                        <button
                          onClick={() => {
                            setExpandedLiveIps(prev => ({
                              ...prev,
                              [visitor.ipAddress]: !prev[visitor.ipAddress]
                            }));
                          }}
                          className="btn btn-outline-secondary btn-sm"
                        >
                          {isExpanded ? 'Hide' : `Show (${visitor.eventsCount})`}
                        </button>
                      </div>
                    </div>

                    {isExpanded && (
                      <div className="p-3 bg-light rounded-3 border d-flex flex-column gap-2">
                        <h5 className="text-uppercase text-muted border-bottom pb-2 mb-2" style={{ fontSize: '10px' }}>
                          Activity Stream (Latest First)
                        </h5>
                        <div className="d-flex flex-column gap-2" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                          {latestEvents.map((event, eIdx) => {
                            const act = getEventActionDetails(event);
                            return (
                              <div key={eIdx} className="p-2 bg-white rounded border d-flex justify-content-between align-items-start gap-2">
                                <div className="min-w-0">
                                  <div className="d-flex align-items-center gap-2 flex-wrap">
                                    <span className={act.badge} style={{ fontSize: '9px' }}>
                                      {act.action}
                                    </span>
                                    <span className="small font-weight-bold text-dark">
                                      {act.details}
                                    </span>
                                  </div>
                                  <div className="small text-muted font-monospace text-truncate mt-1" style={{ fontSize: '11px' }}>
                                    {event.url}
                                  </div>
                                </div>
                                <span className="small text-muted font-monospace shrink-0" style={{ fontSize: '10px' }}>
                                  {new Date(event.timestamp).toLocaleTimeString()}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })
            ) : (
              <p className="small text-muted text-center py-4 mb-0">Waiting for live tracking data stream...</p>
            )}
          </div>
        </div>
      </div>
    );
  };

  const renderAudienceTab = () => {
    const sessionsByCountry = {};
    stats?.sessionsList?.forEach(session => {
      const country = session.country || 'India (Local Network)';
      if (!sessionsByCountry[country]) {
        sessionsByCountry[country] = {
          name: country,
          totalEvents: 0,
          visitors: []
        };
      }
      sessionsByCountry[country].totalEvents += session.eventsCount;
      sessionsByCountry[country].visitors.push(session);
    });

    const countriesList = Object.values(sessionsByCountry).sort((a, b) => b.totalEvents - a.totalEvents);

    const osStats = {};
    stats?.sessionsList?.forEach(s => {
      const osName = s.os || 'Unknown OS';
      osStats[osName] = (osStats[osName] || 0) + 1;
    });

    return (
      <div className="row g-4">
        {/* Geo Demographics */}
        <div className="col-lg-6">
          <div className="card-premium h-100">
            <h3 className="h5 text-dark mb-4">Visitor Geo Demographics</h3>
            <div className="d-flex flex-column gap-3">
              {countriesList.length > 0 ? (
                countriesList.map((country, index) => {
                  const isExpanded = !!expandedGeoCountries[country.name];
                  return (
                    <div key={index} className="border rounded-3 overflow-hidden bg-white">
                      <div 
                        onClick={() => {
                          setExpandedGeoCountries(prev => ({
                            ...prev,
                            [country.name]: !prev[country.name]
                          }));
                        }}
                        className="d-flex justify-content-between align-items-center p-3 select-none"
                        style={{ cursor: 'pointer' }}
                      >
                        <div>
                          <span className="font-weight-bold text-dark">{country.name}</span>
                          <span className="small text-muted font-monospace ms-2">({country.visitors.length} visitors)</span>
                        </div>
                        <div className="d-flex align-items-center gap-2">
                          <span className="badge bg-light border text-primary font-monospace">
                            {country.totalEvents} events
                          </span>
                          <span className="small text-muted">{isExpanded ? '▲' : '▼'}</span>
                        </div>
                      </div>

                      {isExpanded && (
                        <div className="p-3 bg-light border-top d-flex flex-column gap-2" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                          {country.visitors.map((visitor, vIdx) => {
                            const landingEvent = visitor.events[visitor.events.length - 1];
                            const trafficSource = getTrafficSource(landingEvent?.referrer);
                            return (
                              <div key={vIdx} className="bg-white border p-2.5 rounded-3 d-flex justify-content-between align-items-center gap-3">
                                <div className="min-w-0">
                                  <div className="small font-weight-bold text-dark truncate">
                                    {visitor.userName}
                                    <span className="badge bg-light text-muted ms-2" style={{ fontSize: '9px' }}>
                                      City: {visitor.city || 'Noida (Local)'}
                                    </span>
                                  </div>
                                  <div className="small text-muted font-monospace mt-1" style={{ fontSize: '11px' }}>IP: {visitor.ipAddress}</div>
                                </div>
                                <div className="shrink-0 d-flex flex-column align-items-end gap-1">
                                  <span className="badge bg-success font-monospace" style={{ fontSize: '9px' }}>
                                    {visitor.eventsCount} actions
                                  </span>
                                  <span className={trafficSource.color} style={{ fontSize: '9px' }}>
                                    {trafficSource.name}
                                  </span>
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })
              ) : (
                <p className="small text-muted text-center py-4 mb-0">No geographic visitor data recorded yet.</p>
              )}
            </div>
          </div>
        </div>

        {/* Technology Breakdown */}
        <div className="col-lg-6">
          <div className="card-premium h-100">
            <h3 className="h5 text-dark mb-4">Audience Technology Breakdown</h3>
            <div className="d-flex flex-column gap-4">
              {/* Devices */}
              <div>
                <h4 className="small text-muted text-uppercase font-weight-bold mb-3" style={{ fontSize: '10px' }}>Devices</h4>
                <div className="d-flex flex-column gap-2">
                  {Object.entries(stats?.deviceStats || {}).map(([device, count]) => {
                    const total = Object.values(stats?.deviceStats || {}).reduce((a, b) => a + b, 0) || 1;
                    const pct = Math.round((count / total) * 100);
                    return (
                      <div key={device}>
                        <div className="d-flex justify-content-between small mb-1">
                          <span className="text-dark">{device}</span>
                          <span className="text-muted font-monospace">{count} ({pct}%)</span>
                        </div>
                        <div className="progress" style={{ height: '6px' }}>
                          <div className="progress-bar bg-primary" role="progressbar" style={{ width: `${pct}%` }}></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* OS */}
              <div className="border-top pt-3">
                <h4 className="small text-muted text-uppercase font-weight-bold mb-3" style={{ fontSize: '10px' }}>Operating Systems</h4>
                <div className="d-flex flex-column gap-2">
                  {Object.entries(osStats).map(([osName, count]) => {
                    const total = Object.values(osStats).reduce((a, b) => a + b, 0) || 1;
                    const pct = Math.round((count / total) * 100);
                    return (
                      <div key={osName}>
                        <div className="d-flex justify-content-between small mb-1">
                          <span className="text-dark">{osName}</span>
                          <span className="text-muted font-monospace">{count} ({pct}%)</span>
                        </div>
                        <div className="progress" style={{ height: '6px' }}>
                          <div className="progress-bar bg-success" role="progressbar" style={{ width: `${pct}%` }}></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* Browsers */}
              <div className="border-top pt-3">
                <h4 className="small text-muted text-uppercase font-weight-bold mb-3" style={{ fontSize: '10px' }}>Browsers</h4>
                <div className="d-flex flex-column gap-2">
                  {Object.entries(stats?.browserStats || {}).map(([browser, count]) => {
                    const total = Object.values(stats?.browserStats || {}).reduce((a, b) => a + b, 0) || 1;
                    const pct = Math.round((count / total) * 100);
                    return (
                      <div key={browser}>
                        <div className="d-flex justify-content-between small mb-1">
                          <span className="text-dark">{browser}</span>
                          <span className="text-muted font-monospace">{count} ({pct}%)</span>
                        </div>
                        <div className="progress" style={{ height: '6px' }}>
                          <div className="progress-bar bg-info" role="progressbar" style={{ width: `${pct}%` }}></div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderSessionsTab = () => {
    const totalSessions = stats?.sessionsList?.length || 0;
    const totalPages = Math.ceil(totalSessions / sessionsPerPage);
    const paginatedSessions = stats?.sessionsList 
      ? stats.sessionsList.slice((sessionsPage - 1) * sessionsPerPage, sessionsPage * sessionsPerPage)
      : [];

    const toggleSession = (sessionId) => {
      setExpandedSessions(prev => ({ ...prev, [sessionId]: !prev[sessionId] }));
      if (!sessionEventsPages[sessionId]) {
        setSessionEventsPages(prev => ({ ...prev, [sessionId]: 1 }));
      }
    };

    const handleSessionEventPageChange = (sessionId, newPage) => {
      setSessionEventsPages(prev => ({ ...prev, [sessionId]: newPage }));
    };

    return (
      <div className="card-premium">
        <div className="mb-4">
          <h3 className="h5 text-dark mb-1">Session Journey Log</h3>
          <p className="small text-muted mb-0">Replay chronologically mapped flows for each user visit session.</p>
        </div>

        <div className="table-responsive border rounded-3">
          <table className="table table-striped table-hover mb-0">
            <thead>
              <tr>
                <th className="px-3 py-3">Visitor Name / IP</th>
                <th className="px-3 py-3">Device / Browser</th>
                <th className="px-3 py-3">Traffic Source</th>
                <th className="px-3 py-3">Geographic Origin</th>
                <th className="px-3 py-3">Start Time</th>
                <th className="px-3 py-3">Duration</th>
                <th className="px-3 py-3 text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedSessions.length > 0 ? (
                paginatedSessions.map((session, index) => {
                  const isExpanded = !!expandedSessions[session.sessionId];
                  const eventPage = sessionEventsPages[session.sessionId] || 1;
                  const eventsLimit = 5;
                  
                  const sortedEvents = [...session.events].sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
                  const paginatedEvents = sortedEvents.slice((eventPage - 1) * eventsLimit, eventPage * eventsLimit);
                  const totalEventPages = Math.ceil(session.events.length / eventsLimit);
                  
                  const chronEvents = [...session.events].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
                  const landingEvent = chronEvents[0];
                  const trafficSource = getTrafficSource(landingEvent?.referrer);

                  return (
                    <React.Fragment key={session.sessionId || index}>
                      <tr className="event-row">
                        <td className="px-3 py-3">
                          <div className="font-weight-bold text-primary">
                            {session.userName || 'Anonymous Visitor'}
                          </div>
                          <div className="small text-muted font-monospace mt-0.5" style={{ fontSize: '11px' }}>
                            IP: {session.ipAddress || '127.0.0.1'}
                          </div>
                          <div className="small text-muted mt-1" style={{ fontSize: '10px' }}>
                            Pages: {session.pages.length} ({session.eventsCount} events)
                          </div>
                        </td>
                        <td className="px-3 py-3">
                          <div className="small text-dark font-weight-bold">{session.os || 'Unknown OS'}</div>
                          <div className="small text-muted" style={{ fontSize: '11px' }}>{session.device} • {session.browser}</div>
                        </td>
                        <td className="px-3 py-3">
                          <span className={trafficSource.color} style={{ fontSize: '10px' }}>
                            {trafficSource.name}
                          </span>
                        </td>
                        <td className="px-3 py-3">
                          <div className="small text-dark">{session.country || 'India'}</div>
                          <div className="small text-muted" style={{ fontSize: '10px' }}>{session.city || 'Noida (Local)'}</div>
                        </td>
                        <td className="px-3 py-3 small text-muted font-monospace">
                          {new Date(session.startTime).toLocaleString()}
                        </td>
                        <td className="px-3 py-3 font-monospace small text-dark">
                           {formatDuration(session.duration)}
                        </td>
                        <td className="px-3 py-3 text-end">
                          <button
                            onClick={() => toggleSession(session.sessionId)}
                            className="btn btn-outline-secondary btn-sm"
                          >
                            {isExpanded ? 'Hide' : 'Show'}
                          </button>
                        </td>
                      </tr>

                      {isExpanded && (
                        <tr>
                          <td colSpan="7" className="bg-light p-3 border-bottom">
                            <div className="p-3 bg-white border rounded-3 d-flex flex-column gap-3">
                              <div className="d-flex justify-content-between align-items-center border-bottom pb-2">
                                <h4 className="small text-primary text-uppercase font-weight-bold mb-0" style={{ fontSize: '11px' }}>
                                  Chronological Event Stream (Latest First)
                                </h4>
                                <span className="small text-muted font-monospace" style={{ fontSize: '10px' }}>
                                  Total: {session.events.length} logs
                                </span>
                              </div>

                              <div className="d-flex flex-column gap-2">
                                {paginatedEvents.map((event, eIdx) => {
                                  const isPageView = event.eventType === 'page_view';
                                  const isUnload = event.eventType === 'page_unload';
                                  const isLink = event.eventType === 'link_click';
                                  return (
                                    <div key={eIdx} className="p-2 bg-light border rounded d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2">
                                      <div className="min-w-0">
                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                          <span className={`badge ${
                                            isPageView ? 'bg-primary' : 
                                            isUnload ? 'bg-danger' : 
                                            isLink ? 'bg-info text-dark' : 
                                            'bg-success'
                                          }`} style={{ fontSize: '9px' }}>
                                            {event.eventType ? event.eventType.replace('_', ' ') : 'click'}
                                          </span>
                                          <span className="small font-weight-bold text-dark">
                                            {isPageView ? `Visited Page: "${event.pageTitle || 'N/A'}"` : 
                                             isUnload ? `Left Page: "${event.pageTitle || 'N/A'}" (stayed ${event.duration || 0}s)` : 
                                             isLink ? `Clicked Link: "${event.buttonName}"` : 
                                             `Clicked Button: "${event.buttonName}"`}
                                          </span>
                                        </div>
                                        <div className="small text-muted font-monospace text-truncate mt-1" style={{ fontSize: '11px' }}>
                                          {event.url}
                                        </div>
                                      </div>
                                      
                                      <span className="small text-muted font-monospace shrink-0" style={{ fontSize: '10px' }}>
                                        {new Date(event.timestamp).toLocaleTimeString()}
                                      </span>
                                    </div>
                                  );
                                })}
                              </div>

                              {totalEventPages > 1 && (
                                <div className="d-flex justify-content-between align-items-center mt-2">
                                  <span className="small text-muted" style={{ fontSize: '11px' }}>
                                    Page {eventPage} of {totalEventPages}
                                  </span>
                                  
                                  <div className="btn-group btn-group-sm">
                                    <button
                                      onClick={() => handleSessionEventPageChange(session.sessionId, Math.max(1, eventPage - 1))}
                                      disabled={eventPage === 1}
                                      className="btn btn-outline-secondary"
                                    >
                                      Prev
                                    </button>
                                    <button
                                      onClick={() => handleSessionEventPageChange(session.sessionId, Math.min(totalEventPages, eventPage + 1))}
                                      disabled={eventPage === totalEventPages}
                                      className="btn btn-outline-secondary"
                                    >
                                      Next
                                    </button>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="7" className="text-center py-4 text-muted">
                    No visitor session records available.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center mt-4">
            <span className="small text-muted">
              Page {sessionsPage} of {totalPages}
            </span>
            <div className="btn-group btn-group-sm">
              <button
                onClick={() => setSessionsPage(p => Math.max(1, p - 1))}
                disabled={sessionsPage === 1}
                className="btn btn-outline-secondary"
              >
                Previous
              </button>
              <button
                onClick={() => setSessionsPage(p => Math.min(totalPages, p + 1))}
                disabled={sessionsPage === totalPages}
                className="btn btn-outline-secondary"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderIpClicksTab = () => {
    const ipClicks = stats?.ipClicksList || [];
    const groupedByIp = {};
    ipClicks.forEach(item => {
      const ip = item.ipAddress || '127.0.0.1';
      if (!groupedByIp[ip]) {
        groupedByIp[ip] = {
          ipAddress: ip,
          userName: item.userName || 'Anonymous Visitor',
          totalClicks: 0,
          uniqueButtons: 0,
          clicks: []
        };
      }
      groupedByIp[ip].totalClicks += item.count;
      groupedByIp[ip].uniqueButtons += 1;
      groupedByIp[ip].clicks.push(item);
    });

    const visitorsList = Object.values(groupedByIp).sort((a, b) => b.totalClicks - a.totalClicks);
    const filteredVisitors = visitorsList.filter(v => 
      (v.userName && v.userName.toLowerCase().includes(ipClicksSearchTerm.toLowerCase())) ||
      (v.ipAddress && v.ipAddress.toLowerCase().includes(ipClicksSearchTerm.toLowerCase())) ||
      v.clicks.some(c => 
        (c.buttonName && c.buttonName.toLowerCase().includes(ipClicksSearchTerm.toLowerCase())) ||
        (c.pageTitle && c.pageTitle.toLowerCase().includes(ipClicksSearchTerm.toLowerCase())) ||
        (c.url && c.url.toLowerCase().includes(ipClicksSearchTerm.toLowerCase()))
      )
    );

    const totalVisitors = filteredVisitors.length;
    const totalPages = Math.ceil(totalVisitors / ipClicksPerPage);
    const paginatedVisitors = filteredVisitors.slice(
      (ipClicksPage - 1) * ipClicksPerPage, 
      ipClicksPage * ipClicksPerPage
    );

    return (
      <div className="card-premium">
        <div className="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-3 mb-4">
          <div>
            <h3 className="h5 text-dark mb-1">Button Click Analytics</h3>
            <p className="small text-muted mb-0">Track which buttons each visitor clicked, sorted by most clicks first.</p>
          </div>
          
          <div className="w-100 w-sm-auto" style={{ maxWidth: '250px' }}>
            <input
              type="text"
              value={ipClicksSearchTerm}
              onChange={(e) => { setIpClicksSearchTerm(e.target.value); setIpClicksPage(1); }}
              placeholder="Search Visitor, IP..."
              className="form-control form-control-sm"
            />
          </div>
        </div>

        <div className="table-responsive border rounded-3">
          <table className="table table-striped table-hover mb-0">
            <thead>
              <tr>
                <th className="px-3 py-3">Visitor / IP</th>
                <th className="px-3 py-3">Unique Buttons</th>
                <th className="px-3 py-3">Total Interaction Clicks</th>
                <th className="px-3 py-3 text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              {paginatedVisitors.length > 0 ? (
                paginatedVisitors.map((visitor, index) => {
                  const isExpanded = !!expandedIpClicks[visitor.ipAddress];
                  const sortedClicks = [...visitor.clicks].sort((a, b) => b.count - a.count);

                  return (
                    <React.Fragment key={visitor.ipAddress || index}>
                      <tr className="event-row">
                        <td className="px-3 py-3">
                          <div className="font-weight-bold text-primary">
                            {visitor.userName}
                          </div>
                          <div className="small text-muted font-monospace mt-0.5" style={{ fontSize: '11px' }}>
                            IP: {visitor.ipAddress}
                          </div>
                        </td>
                        <td className="px-3 py-3 small text-dark font-monospace">
                          {visitor.uniqueButtons} buttons
                        </td>
                        <td className="px-3 py-3 small font-weight-bold text-success font-monospace">
                          {visitor.totalClicks} clicks
                        </td>
                        <td className="px-3 py-3 text-end">
                          <button
                            onClick={() => {
                              setExpandedIpClicks(prev => ({ ...prev, [visitor.ipAddress]: !prev[visitor.ipAddress] }));
                            }}
                            className="btn btn-outline-secondary btn-sm"
                          >
                            {isExpanded ? 'Hide' : 'Details'}
                          </button>
                        </td>
                      </tr>

                      {isExpanded && (
                        <tr>
                          <td colSpan="4" className="bg-light p-3 border-bottom">
                            <div className="p-3 bg-white border rounded-3 d-flex flex-column gap-2">
                              <h4 className="small text-primary text-uppercase font-weight-bold border-bottom pb-2 mb-2" style={{ fontSize: '11px' }}>
                                Interactions Detail (Highest Clicks First)
                              </h4>
                              <div className="d-flex flex-column gap-2">
                                {sortedClicks.map((clickItem, cIdx) => (
                                  <div key={cIdx} className="p-2 bg-light border rounded d-flex justify-content-between align-items-center gap-3">
                                    <div className="min-w-0">
                                      <div className="d-flex align-items-center gap-2 flex-wrap">
                                        <span className="badge bg-primary text-white" style={{ fontSize: '10px' }}>
                                          {clickItem.buttonName}
                                        </span>
                                        <span className="small text-muted">
                                          on page: "{clickItem.pageTitle || 'N/A'}"
                                        </span>
                                      </div>
                                      <div className="small text-muted font-monospace text-truncate mt-1" style={{ fontSize: '11px' }}>
                                        {clickItem.url}
                                      </div>
                                    </div>
                                    <span className="badge bg-success font-monospace">
                                      {clickItem.count} clicks
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </td>
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="4" className="text-center py-4 text-muted">
                    No matching visitors found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        {totalPages > 1 && (
          <div className="d-flex justify-content-between align-items-center mt-4">
            <span className="small text-muted">
              Page {ipClicksPage} of {totalPages}
            </span>
            <div className="btn-group btn-group-sm">
              <button
                onClick={() => setIpClicksPage(p => Math.max(1, p - 1))}
                disabled={ipClicksPage === 1}
                className="btn btn-outline-secondary"
              >
                Previous
              </button>
              <button
                onClick={() => setIpClicksPage(p => Math.min(totalPages, p + 1))}
                disabled={ipClicksPage === totalPages}
                className="btn btn-outline-secondary"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderDbConfigTab = () => {
    const currentDbType = stats?.dbType || 'file';
    return (
      <div className="d-flex flex-column gap-4">
        <div>
          <h2 className="h4 text-dark mb-1">Database Settings & Integrations</h2>
          <p className="small text-muted mb-0">Configure multi-database adapters to pipe and store raw tracking logs dynamically.</p>
        </div>

        {/* Connection Status */}
        <div className="card-premium d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3">
          <div>
            <h3 className="small text-muted text-uppercase font-weight-bold mb-1" style={{ fontSize: '11px' }}>Active Database Connection</h3>
            <span className="h5 text-primary font-weight-bold">
              {currentDbType === 'file' && 'Local System (JSON File)'}
              {currentDbType === 'mongodb' && 'MongoDB Atlas / Server'}
              {currentDbType === 'mysql' && 'MySQL Database'}
              {currentDbType === 'azure' && 'Azure SQL Server'}
            </span>
            <p className="small text-muted font-monospace mt-2 mb-0 text-break" style={{ fontSize: '11px' }}>
              Configuration: {currentDbType === 'file' ? (stats?.dbConfig?.filePath || './data/tracking-data.json') : 
                             currentDbType === 'mongodb' ? (stats?.dbConfig?.connectionString ? stats.dbConfig.connectionString.replace(/:([^:@]+)@/, ':****@') : 'N/A') :
                             `${stats?.dbConfig?.username || ''}@${stats?.dbConfig?.host || ''}:${stats?.dbConfig?.port || ''}/${stats?.dbConfig?.database || ''}`}
            </p>
          </div>
          <span className="badge bg-success py-2 px-3 text-uppercase font-weight-bold">Connected</span>
        </div>

        {/* Selection Cards */}
        <div className="row g-3">
          {[
            { id: 'file', label: 'Local System', desc: 'JSON/SQLite File' },
            { id: 'mongodb', label: 'MongoDB', desc: 'NoSQL Database' },
            { id: 'mysql', label: 'MySQL', desc: 'Relational DB' },
            { id: 'azure', label: 'Azure Server', desc: 'MS SQL Server' }
          ].map(db => (
            <div key={db.id} className="col-6 col-md-3" onClick={() => setDbTypeSel(db.id)}>
              <div 
                className={`p-3 rounded border text-start h-100 ${
                  dbTypeSel === db.id ? 'bg-light border-primary border-2' : 'bg-white border-light'
                }`}
                style={{ cursor: 'pointer', transition: 'all 0.2s' }}
              >
                <span className="font-weight-bold text-dark d-block mb-1">{db.label}</span>
                <span className="small text-muted d-block">{db.desc}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Forms */}
        <div className="card-premium">
          {dbTypeSel === 'file' && (
            <form onSubmit={(e) => handleDbConnectNew(e, 'file')} className="d-flex flex-column gap-3">
              <h3 className="h6 text-dark font-weight-bold mb-0">Local System JSON Configuration</h3>
              <div className="form-group">
                <label className="small text-muted mb-1">File Path</label>
                <input
                  type="text"
                  value={fileDbPath}
                  onChange={(e) => setFileDbPath(e.target.value)}
                  placeholder="./data/tracking-data.json"
                  className="form-control"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary btn-sm align-self-start">Save & Connect File</button>
            </form>
          )}

          {dbTypeSel === 'mongodb' && (
            <form onSubmit={(e) => handleDbConnectNew(e, 'mongodb')} className="d-flex flex-column gap-3">
              <h3 className="h6 text-dark font-weight-bold mb-0">MongoDB Server Configuration</h3>
              <div className="row g-3">
                <div className="col-12">
                  <label className="small text-muted mb-1">Connection URI (String)</label>
                  <input
                    type="text"
                    value={mongoUri}
                    onChange={(e) => setMongoUri(e.target.value)}
                    placeholder="mongodb+srv://user:pass@cluster.mongodb.net/?retryWrites=true&w=majority"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="small text-muted mb-1">Database Name</label>
                  <input
                    type="text"
                    value={mongoDbName}
                    onChange={(e) => setMongoDbName(e.target.value)}
                    placeholder="tracking"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="small text-muted mb-1">Collection Name</label>
                  <input
                    type="text"
                    value={mongoCollName}
                    onChange={(e) => setMongoCollName(e.target.value)}
                    placeholder="clicks"
                    className="form-control"
                    required
                  />
                </div>
              </div>
              <button type="submit" className="btn btn-primary btn-sm align-self-start mt-2">Save & Connect MongoDB</button>
            </form>
          )}

          {dbTypeSel === 'mysql' && (
            <form onSubmit={(e) => handleDbConnectNew(e, 'mysql')} className="d-flex flex-column gap-3">
              <h3 className="h6 text-dark font-weight-bold mb-0">MySQL Database Configuration</h3>
              <div className="row g-3">
                <div className="col-md-8">
                  <label className="small text-muted mb-1">Database Host</label>
                  <input
                    type="text"
                    value={mysqlHost}
                    onChange={(e) => setMysqlHost(e.target.value)}
                    placeholder="localhost"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-4">
                  <label className="small text-muted mb-1">Port</label>
                  <input
                    type="number"
                    value={mysqlPort}
                    onChange={(e) => setMysqlPort(e.target.value)}
                    placeholder="3306"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-4">
                  <label className="small text-muted mb-1">Username</label>
                  <input
                    type="text"
                    value={mysqlUser}
                    onChange={(e) => setMysqlUser(e.target.value)}
                    placeholder="root"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-4">
                  <label className="small text-muted mb-1">Password</label>
                  <input
                    type="password"
                    value={mysqlPass}
                    onChange={(e) => setMysqlPass(e.target.value)}
                    placeholder="password"
                    className="form-control"
                  />
                </div>
                <div className="col-md-4">
                  <label className="small text-muted mb-1">Database Name</label>
                  <input
                    type="text"
                    value={mysqlDb}
                    onChange={(e) => setMysqlDb(e.target.value)}
                    placeholder="tracking_db"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="small text-muted mb-1">Table Name</label>
                  <input
                    type="text"
                    value={mysqlTable}
                    onChange={(e) => setMysqlTable(e.target.value)}
                    placeholder="clicks"
                    className="form-control"
                    required
                  />
                </div>
              </div>
              <button type="submit" className="btn btn-primary btn-sm align-self-start mt-2">Save & Connect MySQL</button>
            </form>
          )}

          {dbTypeSel === 'azure' && (
            <form onSubmit={(e) => handleDbConnectNew(e, 'azure')} className="d-flex flex-column gap-3">
              <h3 className="h6 text-dark font-weight-bold mb-0">Azure SQL Server Configuration</h3>
              <div className="row g-3">
                <div className="col-md-8">
                  <label className="small text-muted mb-1">Server Host</label>
                  <input
                    type="text"
                    value={azureHost}
                    onChange={(e) => setAzureHost(e.target.value)}
                    placeholder="your-azure-db.database.windows.net"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-4">
                  <label className="small text-muted mb-1">Port</label>
                  <input
                    type="number"
                    value={azurePort}
                    onChange={(e) => setAzurePort(e.target.value)}
                    placeholder="1433"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-4">
                  <label className="small text-muted mb-1">Username</label>
                  <input
                    type="text"
                    value={azureUser}
                    onChange={(e) => setAzureUser(e.target.value)}
                    placeholder="azure_admin"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-4">
                  <label className="small text-muted mb-1">Password</label>
                  <input
                    type="password"
                    value={azurePass}
                    onChange={(e) => setAzurePass(e.target.value)}
                    placeholder="password"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-md-4">
                  <label className="small text-muted mb-1">Database Name</label>
                  <input
                    type="text"
                    value={azureDb}
                    onChange={(e) => setAzureDb(e.target.value)}
                    placeholder="tracking_db"
                    className="form-control"
                    required
                  />
                </div>
                <div className="col-12">
                  <label className="small text-muted mb-1">Table Name</label>
                  <input
                    type="text"
                    value={azureTable}
                    onChange={(e) => setAzureTable(e.target.value)}
                    placeholder="clicks"
                    className="form-control"
                    required
                  />
                </div>
              </div>
              <button type="submit" className="btn btn-primary btn-sm align-self-start mt-2">Save & Connect Azure SQL</button>
            </form>
          )}
        </div>
      </div>
    );
  };

  const renderDeleteManagerTab = () => {
    return (
      <div className="d-flex flex-column gap-4">
        <div>
          <h2 className="h4 text-dark mb-1">Data Manager & Logs Deletion</h2>
          <p className="small text-muted mb-0">Purge selective tracking logs, filter by custom date ranges, or clear the entire database securely.</p>
        </div>

        {/* Controls */}
        <div className="row g-3">
          <div className="col-md-4">
            <div className="card-premium h-100 d-flex flex-column justify-content-between">
              <div>
                <h3 className="h6 text-danger text-uppercase font-weight-bold mb-2">Delete Selected Checked</h3>
                <p className="small text-muted mb-3">Select individual checkboxes in the logs table below, then click here to purge them.</p>
              </div>
              <div>
                <div className="small text-muted mb-2 font-monospace">
                  Selected: <span className="text-primary font-weight-bold">{selectedLogIds.length}</span>
                </div>
                <button
                  onClick={handleDeleteChecked}
                  disabled={selectedLogIds.length === 0}
                  className="btn btn-danger btn-sm w-100 font-weight-bold"
                >
                  Delete Checked Logs
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card-premium h-100 d-flex flex-column justify-content-between">
              <div>
                <h3 className="h6 text-primary text-uppercase font-weight-bold mb-2">Delete by Date Range</h3>
                <p className="small text-muted mb-3">Choose a timeframe to delete all recorded logs within those dates.</p>
              </div>
              <div className="d-flex flex-column gap-2">
                <div className="row g-2">
                  <div className="col-6">
                    <input
                      type="date"
                      value={mgrStartDate}
                      onChange={(e) => setMgrStartDate(e.target.value)}
                      className="form-control form-control-sm"
                    />
                  </div>
                  <div className="col-6">
                    <input
                      type="date"
                      value={mgrEndDate}
                      onChange={(e) => setMgrEndDate(e.target.value)}
                      className="form-control form-control-sm"
                    />
                  </div>
                </div>
                <button
                  onClick={handleDeleteRangeMgr}
                  className="btn btn-danger btn-sm w-100 font-weight-bold"
                >
                  Delete Date Range
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-4">
            <div className="card-premium h-100 d-flex flex-column justify-content-between">
              <div>
                <h3 className="h6 text-danger text-uppercase font-weight-bold mb-2">Clear All Logs</h3>
                <p className="small text-muted mb-3">Warning: This action is permanent and clears all recorded visitor event logs.</p>
              </div>
              <button
                onClick={handleDeleteAllMgr}
                className="btn btn-outline-danger btn-sm w-100 font-weight-bold"
              >
                Purge Entire Database
              </button>
            </div>
          </div>
        </div>

        {/* Logs Table */}
        <div className="card-premium">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="h6 mb-0 text-dark font-weight-bold">Visitor Event Records ({deleteTabTotalCount} total)</h3>
            {selectedLogIds.length > 0 && (
              <span className="small text-muted">
                Selected: <span className="text-primary font-weight-bold">{selectedLogIds.length}</span> / {allLogs.length} on page
              </span>
            )}
          </div>

          {deleteTabLoading ? (
            <div className="d-flex justify-content-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : allLogs.length === 0 ? (
            <div className="text-center py-4 text-muted small">No visitor logs found.</div>
          ) : (
            <div className="d-flex flex-column gap-3">
              <div className="table-responsive border rounded-3">
                <table className="table table-striped table-hover mb-0">
                  <thead>
                    <tr>
                      <th className="p-3 w-12 text-center" style={{ width: '40px' }}>
                        <input
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={allLogs.length > 0 && selectedLogIds.length === allLogs.length}
                          className="form-check-input"
                        />
                      </th>
                      <th className="px-3 py-3">Timestamp</th>
                      <th className="px-3 py-3">User / IP</th>
                      <th className="px-3 py-3">Page Title</th>
                      <th className="px-3 py-3">Action / Button</th>
                      <th className="px-3 py-3">Location</th>
                    </tr>
                  </thead>
                  <tbody>
                    {allLogs.map((log) => {
                      const isChecked = selectedLogIds.includes(log.id);
                      return (
                        <tr key={log.id} className="event-row">
                          <td className="p-3 text-center">
                            <input
                              type="checkbox"
                              checked={isChecked}
                              onChange={() => handleToggleCheckbox(log.id)}
                              className="form-check-input"
                            />
                          </td>
                          <td className="px-3 py-3 font-monospace small text-muted">
                            {new Date(log.timestamp).toLocaleString()}
                          </td>
                          <td className="px-3 py-3">
                            <div className="small font-weight-bold text-dark">{log.realName || log.ipAddress}</div>
                            <div className="small text-muted font-monospace" style={{ fontSize: '10px' }}>{log.ipAddress}</div>
                          </td>
                          <td className="px-3 py-3 small text-dark">
                            <div className="text-truncate" style={{ maxWidth: '200px' }}>{log.pageTitle || 'N/A'}</div>
                          </td>
                          <td className="px-3 py-3">
                            <span className="badge bg-primary">
                              {log.buttonName}
                            </span>
                          </td>
                          <td className="px-3 py-3 small text-dark">
                            <div>{log.country || 'India'}</div>
                            <div className="small text-muted" style={{ fontSize: '10px' }}>{log.city || 'Noida (Local)'}</div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {deleteTabTotalPages > 1 && (
                <div className="d-flex justify-content-between align-items-center mt-2">
                  <span className="small text-muted">
                    Page {deleteTabPage} of {deleteTabTotalPages}
                  </span>
                  <div className="btn-group btn-group-sm">
                    <button
                      onClick={() => setDeleteTabPage(p => Math.max(1, p - 1))}
                      disabled={deleteTabPage === 1}
                      className="btn btn-outline-secondary"
                    >
                      Previous
                    </button>
                    <button
                      onClick={() => setDeleteTabPage(p => Math.min(deleteTabTotalPages, p + 1))}
                      disabled={deleteTabPage === deleteTabTotalPages}
                      className="btn btn-outline-secondary"
                    >
                      Next
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <section className="dash-section tracking-container">
      <div className="container-fluid p-0">
        <div className="row p-0 m-0">
          <div className="col-12 right-content">
            <div className="head-name mb-4">
              <h3 className="dashboard-module mb-0">User Tracking Tool</h3>
            </div>

            {/* Custom Tab Bar */}
            <div className="tracking-tabs">
              {[
                { id: 'overview', label: 'Overview' },
                { id: 'live', label: 'Live Traffic' },
                { id: 'audience', label: 'Audience' },
                { id: 'sessions', label: 'Sessions Log' },
                { id: 'ipClicks', label: 'Click Analytics' },
                { id: 'slider', label: 'Journey Simulator' },
                { id: 'cdn', label: 'CDN Snippet' },
                { id: 'dbConfig', label: 'Database Config' },
                { id: 'deleteManager', label: 'Delete Manager' }
              ].map(tab => (
                <div
                  key={tab.id}
                  onClick={() => handleTabChange(tab.id)}
                  className={`tracking-tab-item ${activeTab === tab.id ? 'active' : ''}`}
                >
                  {tab.label}
                </div>
              ))}
            </div>

            {/* Tab content */}
            {loading ? (
              <div className="d-flex justify-content-center align-items-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="tab-content-area">
                {activeTab === 'overview' && renderOverviewTab()}
                {activeTab === 'live' && renderLiveTab()}
                {activeTab === 'audience' && renderAudienceTab()}
                {activeTab === 'sessions' && renderSessionsTab()}
                {activeTab === 'ipClicks' && renderIpClicksTab()}
                {activeTab === 'slider' && <SliderPage />}
                {activeTab === 'cdn' && <CDNGenerator />}
                {activeTab === 'dbConfig' && renderDbConfigTab()}
                {activeTab === 'deleteManager' && renderDeleteManagerTab()}
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UserTrackingDashboard;
